import { Link } from 'react-router-dom';

function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-blue-600 text-white shadow-lg">
        <div className="container mx-auto px-4 py-6">
          <Link to="/" className="text-4xl font-bold hover:text-blue-100 transition">📰 NotíciasWeb</Link>
        </div>
      </header>

      <main className="container mx-auto px-4 py-12 max-w-4xl">
        <h1 className="text-4xl font-bold text-gray-800 mb-8">Política de Privacidade</h1>
        
        <div className="bg-white rounded-lg shadow-md p-8 prose prose-lg max-w-none">
          <p className="text-gray-600 mb-6">Data de última atualização: {new Date().toLocaleDateString('pt-BR')}</p>

          <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-4">1. Informações que Coletamos</h2>
          <p className="text-gray-700 mb-4">
            O NotíciasWeb coleta as seguintes informações quando você utiliza nosso site:
          </p>
          <ul className="list-disc pl-6 text-gray-700 mb-6">
            <li>Informações de navegação (páginas visitadas, tempo de permanencia)</li>
            <li>Dados técnicos (endereço IP, tipo de navegador, sistema operacional)</li>
            <li>Cookies e tecnologias semelhantes</li>
            <li>Informações fornecidas voluntariamente (formulário de contato)</li>
          </ul>

          <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-4">2. Como Usamos Suas Informações</h2>
          <p className="text-gray-700 mb-4">
            Utilizamos as informações coletadas para:
          </p>
          <ul className="list-disc pl-6 text-gray-700 mb-6">
            <li>Melhorar a experiência do usuário</li>
            <li>Personalizar conteúdo e anúncios</li>
            <li>Analisar o tráfego e comportamento dos visitantes</li>
            <li>Responder a solicitações de contato</li>
            <li>Cumprir obrigações legais</li>
          </ul>

          <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-4">3. Cookies</h2>
          <p className="text-gray-700 mb-4">
            Utilizamos cookies para melhorar sua experiência de navegação. Você pode controlar o uso de cookies 
            através das configurações do seu navegador.
          </p>

          <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-4">4. Google AdSense</h2>
          <p className="text-gray-700 mb-4">
            Este site utiliza o Google AdSense para exibir anúncios. O Google pode usar cookies para 
            personalizar anúncios com base em suas visitas anteriores ao nosso site ou a outros sites.
          </p>

          <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-4">5. Compartilhamento de Dados</h2>
          <p className="text-gray-700 mb-4">
            Não vendemos, alugamos ou compartilhamos suas informações pessoais com terceiros, exceto:
          </p>
          <ul className="list-disc pl-6 text-gray-700 mb-6">
            <li>Quando exigido por lei</li>
            <li>Com provedores de serviços que nos auxiliam (Google Analytics, AdSense)</li>
            <li>Com seu consentimento explícito</li>
          </ul>

          <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-4">6. Seus Direitos (LGPD)</h2>
          <p className="text-gray-700 mb-4">
            De acordo com a Lei Geral de Proteção de Dados (LGPD), você tem direito a:
          </p>
          <ul className="list-disc pl-6 text-gray-700 mb-6">
            <li>Acessar seus dados pessoais</li>
            <li>Corrigir dados incompletos ou desatualizados</li>
            <li>Solicitar a exclusão de seus dados</li>
            <li>Revogar seu consentimento</li>
          </ul>

          <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-4">7. Contato</h2>
          <p className="text-gray-700 mb-4">
            Para questões sobre privacidade, entre em contato conosco através do{' '}
            <Link to="/contato" className="text-blue-600 hover:underline">formulário de contato</Link>.
          </p>
        </div>

        <div className="mt-8 text-center">
          <Link to="/" className="text-blue-600 hover:underline">← Voltar para home</Link>
        </div>
      </main>
    </div>
  );
}

export default PrivacyPolicy;